module.exports = __webpack_public_path__ + "assets/img/408a523d3e9ba0f463beeceda4f0e18a.webp";